import React, { type ReactElement, useCallback } from 'react'
import { useSnapshot } from 'valtio'
import { customerAddProxy } from '../../../../../../../../shared/components/CustomerAddSlideOver/customerAddProxy'
import { proxyGlobalAuth } from '../../../../../../../../shared/proxies/proxyGlobalAuth'
import AddEntityButton from '../../../../../../../../shared/components/ui/buttons/AddEntityButton'
import PlusIcon from '../../../../../../../../shared/components/ui/icons/PlusIcon'
import { GtagEvents, gtmTrackButtonPress } from '../../../../../../../../shared/utils/gtmUtils'

export function AddCustomerButton (): ReactElement {
  const onClick = useCallback(() => {
    customerAddProxy.displaySlideOver = true
    gtmTrackButtonPress(GtagEvents.CUSTOMER_MODAL_OPEN)
  }, [])

  const { siteTheme: { addEntityButton } } = useSnapshot(proxyGlobalAuth)

  return (
    <AddEntityButton clickFunction={onClick} icon={<PlusIcon color={addEntityButton.iconClasses} />} text="New Customer" />
  )
}
